export default function PHP_strtotime() {
  return (
    <div>
      <h1>PHP_strtotime</h1>
    </div>
  );
}
